export enum ReportFrequencyEnum{
    HOURLY = "HOURLY",
    WEEKLY = "WEEKLY",
    MONTHLY = "MONTHLY"
}